import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { CKBox, CKButton, CKDrawer } from 'clearkit';

import TextField from '~/components/RedesignedTextField';

import styles from './styles';
import UpgradePlanItem from './UpgradePlanItem';
import UpgradePlanSection from './UpgradePlanSection';

export const addonOptions = [
  'advertising',
  'conversion_tracking',
  'dynamic_content',
  'form_shortening',
  'google_analytics',
  'data_enrichment',
  'lead_management',
  'revenue_insights',
];

export function isValid(values) {
  const anyOptionSelected = addonOptions.some((i) => values[i]);

  if (values.other && !values.message) {
    return false;
  }

  return values.email !== '' && values.name !== '' && anyOptionSelected;
}

function RequestAccessForm({
  classes,
  values,
  onChange,
  onClose,
  valid,
  onSubmit,
}) {
  return (
    <form className="flex flex-col overflow-hidden" onSubmit={onSubmit}>
      <CKDrawer.Body className="p-6">
        <CKBox variant="card">
          <div className={classes.contactInfo}>
            <FormControl className={classes.field} fullWidth>
              <FormLabel>Email address*</FormLabel>
              <TextField
                onChange={(event) => onChange('email', event.target.value)}
                value={values.email}
              />
            </FormControl>

            <FormControl className={classes.field} fullWidth>
              <FormLabel>Name*</FormLabel>
              <TextField
                onChange={(event) => onChange('name', event.target.value)}
                value={values.name}
              />
            </FormControl>
          </div>

          <div className={classes.planOptions}>
            <p className="text-lg text-gray-600">
              Let us know what you're interested in
            </p>

            <UpgradePlanSection addon="acquisitions" title="Create demand">
              <UpgradePlanItem
                addon="acquisitions"
                description="Reach more decision makers at target accounts"
                name="advertising"
                onChange={onChange}
                title="Precise B2B ad targeting"
                values={values}
              />
              <UpgradePlanItem
                addon="acquisitions"
                description="Train ads to convert qualified leads, without cookies"
                name="conversion_tracking"
                onChange={onChange}
                title="Enhance ad performance tracking"
                values={values}
              />
            </UpgradePlanSection>

            <UpgradePlanSection addon="conversions" title="Convert intent">
              <UpgradePlanItem
                addon="conversions"
                description="Increase conversion with relevant experiences"
                name="dynamic_content"
                onChange={onChange}
                title="Dynamic web content"
                values={values}
              />
              <UpgradePlanItem
                addon="conversions"
                description="Shorten web forms without losing any leads data"
                name="form_shortening"
                onChange={onChange}
                title="Optimized site conversion"
                values={values}
              />
              <UpgradePlanItem
                addon="conversions"
                description="Drive insights via Google Analytics"
                name="google_analytics"
                onChange={onChange}
                title="Improve marketing attribution"
                values={values}
              />
            </UpgradePlanSection>

            <UpgradePlanSection addons="operations" title="Accelerate revenue">
              <UpgradePlanItem
                addons="operations"
                description="Add accurate, fresh data to new & existing records"
                name="data_enrichment"
                onChange={onChange}
                title="Enriched accounts in CRM/MAP"
                values={values}
              />
              <UpgradePlanItem
                addons="operations"
                description="Score & route leads correctly the first time"
                name="lead_management"
                onChange={onChange}
                title="Error-free lead management"
                values={values}
              />
              <UpgradePlanItem
                addons="operations"
                description="Drive insights with GTM, website and ICP reporting"
                name="revenue_insights"
                onChange={onChange}
                title="Improved revenue insights"
                values={values}
              />
            </UpgradePlanSection>

            <div className="mt-8">
              <UpgradePlanItem
                name="other"
                onChange={onChange}
                title="Other"
                values={values}
              />

              {values.other && (
                <div className="mt-4">
                  <FormControl fullWidth>
                    <FormLabel className="mb-2 font-semibold">
                      Message
                    </FormLabel>
                    <TextField
                      InputProps={{ rel: 'message' }}
                      multiline
                      onChange={(event) =>
                        onChange('message', event.target.value)
                      }
                      placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
                      rows={3}
                      value={values.message}
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </div>
        </CKBox>
      </CKDrawer.Body>
      <CKDrawer.Footer className="gap-3">
        <CKButton onClick={onClose}>Cancel</CKButton>
        <CKButton
          isDisabled={!valid}
          type="submit"
          variant="bold"
          variantColor="blue"
        >
          Submit
        </CKButton>
      </CKDrawer.Footer>
    </form>
  );
}

RequestAccessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
};

export default withStyles(styles)(RequestAccessForm);
